<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"
import { computed, h } from "vue"

import GoHomeButton from "@/components/errors/GoHomeButton.vue"
import AppLayout from "@/layouts/app/AppSidebarLayout.vue"
import type { Auth, BreadcrumbItemType } from "@/types"

interface Props {
  breadcrumbs?: BreadcrumbItemType[]
  title: string
  subtitle?: string
  description?: string
}

const page = usePage()

const Layout = computed(() => {
  const auth = page.props.auth as Auth | null
  return auth?.user
    ? h(AppLayout)
    : h("div", { class: "flex min-h-screen flex-col" })
})

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
})
</script>

<template>
  <Layout>
    <div
      class="bg-background -mt-40 flex min-w-240 grow flex-col items-center justify-center px-4 text-center"
    >
      <p
        v-if="subtitle"
        class="text-muted-foreground text-sm font-semibold tracking-widest uppercase"
      >
        {{ subtitle }}
      </p>
      <h1 class="text-foreground mt-4 text-5xl font-bold tracking-tight">
        {{ title }}
      </h1>
      <p v-if="description" class="text-muted-foreground mt-4 max-w-md">
        {{ description }}
      </p>
      <GoHomeButton />
    </div>
  </Layout>
</template>
